
export function analytic({ category, action, label, value }, callback) {
  window.dataLayer.push({
    event: 'event',
    category: category || 'serasaecred',
    action,
    label: normalizeLabel(label),
    value,
    eventCallback: callback,
    eventTimeout: 100,
  })
}

export function setCustomData(name, flow) {
  window.customData = {
    page: {
      name: name,
      flow: flow,
    },
    site: {
      product: '​ecred',
      area: 'credito',
      version: '​1.0',
      brand: 'serasa',
      channel: '​web'
    },
    user: {
      logged: 'false',
      connection: getConnection(),
    }
  }
}

function getConnection() {
  try {
    return navigator.connection.effectiveType
  } catch (error) {
    return null
  }
}

function normalizeLabel(label) {
  return label.toLowerCase().replace(/\.|\?/g, '').replace('.', '').replace(',', '.').replace(' ', '_').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export default () => {
  function event (event) {
    let callback
    const dataset = this.dataset
    if (dataset.ecsEvent !== 'analytics') {
      return
    }
    let label = dataset.ecsLabel
    if (label == null || label == '') {
      label = this.innerText
    }

    if (this.href) {
      event.preventDefault()
      callback = () => {
        window.location.href = this.href
      }
    }


    analytic({
      category: dataset.ecsCategory,
      action: dataset.ecsAction,
      label,
      value: dataset.ecsValue,
    }, callback)
  }

  [].forEach.call(document.querySelectorAll('[data-ecs-event="analytics"]'), element => {
    element.addEventListener('click', event)
  })
}



// WEBPACK FOOTER //
// ./src/analytics.js